/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Body from '../partials/Body';

import styles from '../../../styles/blocks/excerpt.module.scss';

const propTypes = {
    body: PropTypes.string,
    author: PropTypes.string,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    body: null,
    author: null,
    className: null,
    isContainer: false,
    containerClassName: null,
};

const ExcerptBlock = ({ body, author, className, isContainer, containerClassName }) => {
    const { name = null } = author || {};
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                <div className={styles.quote}>
                    {body !== null ? <Body className={styles.body} body={body} /> : null}
                    {name !== null ? <div className={styles.author}>{name}</div> : null}
                </div>
            </div>
        </div>
    );
};

ExcerptBlock.propTypes = propTypes;
ExcerptBlock.defaultProps = defaultProps;

export default ExcerptBlock;
